export const isEmptyObj = (activeObj) => {
  if (!activeObj) throw new Error(`An object must be provided.`);

  if (Object.keys(activeObj).length === 0) return true;

  return Object.values(activeObj).every((x) => x === null || x === "");
};
